import React from "react";
import PropTypes from "prop-types";
import { graphql, Link } from "gatsby";
import Helmet from "react-helmet";

import Layout, { Container, Title } from "../components/Layout";
import "../styles/home.scss";
import { kebabCase } from "lodash";
import FrontHighlightBlock from "../components/FrontHighlightBlock";
import LazyCalendar from "../components/LazyCalendar";
import NewsItem from "../components/NewsItem";
import { __DEV__ } from "../Constants";

const topIcons = [
  {
    label: "Kakovostno učenje",
    img: "teacher.png"
  },
  {
    label: "Veselje otrok",
    img: "kid.png"
  },
  {
    label: "Skrb za okolje",
    img: "leaf.png"
  },
  {
    label: "Sodelovanje med vsemi",
    img: "hand.png"
  },
  {
    label: "Zdrava prehrana",
    img: "food.png"
  },
  {
    label: "Vrtčevski sklad",
    img: "money.png"
  }
];

class HomePage extends React.Component {
  renderSlidez(bannerItems) {
    const Slideshow = require("react-slidez").default;
    return (
      <div className="homeSlider">
        <Slideshow
          effect={"fade"}
          height={700}
          showArrows
          autoplay
          showIndex
          enableKeyboard
          useDotIndex
          slideInterval={5000}
        >
          {bannerItems.map(({ label, image }) => {
            return (
              <div
                className="homeSlideImg"
                style={{
                  background: `url(${image}) center center no-repeat`,
                  backgroundSize: "cover"
                }}
              >
                <div className="homeSliderLabel">{label}</div>
              </div>
            );
          })}
        </Slideshow>
      </div>
    );
  }
  render() {
    const {
      data: { footerData, navbarData, latestNews, allBlogVelika, homePageData, projects }
    } = this.props;
    const { frontmatter: home } = homePageData.edges[0].node;
    const { bannerItems, highlightTextBlock } = home;
    return (
      <Layout footerData={footerData} navbarData={navbarData} centered={false}>
        <Helmet>
          <meta name="title" content={"seoTitle"} />
          <meta name="description" content={"seoDescription"} />
          <title>{"browserTitle"}</title>
        </Helmet>
        <div style={{ height: 700 }}>
          {__DEV__ && this.renderSlidez(bannerItems)}
        </div>
        <Container>
          <div className="columns luft center">
            <div>
              <h3>Dobrodošli pri nas!</h3>
              <p>
                Osnovna šola Ivana Roba si že vrsto let prizadeva nuditi našim
                otrokom ne le najkakovostnejšo raven učenja temveč tudi vzbuditi
                voljo do dela in učenja ter lepega vedenja. Z izrednimi učitelji
                skušamo premagati težave, ki jih srečujejo otroci skozi razvoj
                in učenje ter pri tem graditi na spoštovanju in ljubezni.
              </p>
            </div>
            <div>
              <img src="/img/otroci.jpg" />
            </div>
          </div>
        </Container>
        <Container>
          <div className="columns luft center">
            <div>
              <img src="/img/teacher_kids.jpg" />
            </div>
            <div>
              <h3>Želja po kvalitetnem učenju in druženju</h3>
              <p>
                V naših prostorih je glavnega pomena, da se vsi počutijo dobro
                in uživajo v družbi. Prvo pravilo je, da se otroci med seboj
                spoštujejo in si pomagajo. Le tako bomo skupaj dosegali
                najboljše rezultate in imele lepe izkušnje.
              </p>
            </div>
          </div>
        </Container>
        <Container>
          <div className="frontStandup">
            <Title>Naše poslanstvo</Title>
            {/* <p>Katere so stvar, ki odlikujejo našo skupnost?</p> */}
            <div className="frontBoxes">
              {topIcons.map(({ img, label }) => {
                return (
                  <div className="box">
                    <img src={`/img/custom/${img}`} alt={label} />
                    {label}
                  </div>
                );
              })}
            </div>
          </div>
        </Container>
        <FrontHighlightBlock text={highlightTextBlock} />
        <Container>
          <Title>Mala Šem5ka</Title>
          <div className="frontNews">
            {latestNews.edges.map(
              ({
                node
              }) => {
                return <NewsItem value={node} />
              }
            )}
          </div>
        </Container>
        <Container>
          <Title>Šem5ka</Title>
          <div className="frontNews">
            {allBlogVelika.edges.map(
              ({
                node
              }) => {
                return <NewsItem value={node} />
              }
            )}
          </div>
        </Container>
        <Container>
          <Title>Koledar dogodkov</Title>
          <LazyCalendar height={400} />
          <Title>Spoznajte več</Title>
          <div className="getToKnow">
            {[
              {
                to: "/krozki",
                label: "Krožki",
                className: "krozki",
                text:
                  "Miselne ni spretnostne aktivnosti za otroke vseh starosti"
              },
              {
                to: "/sportne-aktivnosti",
                className: "sports",
                label: "Športne aktivnosti",
                text:
                  "Od plesa in gimnastike pa vse do rokometa, nogometa in drugih športnih aktivnosti"
              },
              {
                to: "/alumni",
                className: "alumni",
                label: "Alumni",
                text:
                  "Spoznajte nekatere naše bivše člane šole in kakšne so njihove izkušnje pri nas"
              }
            ].map(({ label, text, ...rest }) => (
              <Link {...rest}>
                <b>{label}</b>
                <span>{text}</span>
              </Link>
            ))}
          </div>
          <Title>Iniciative in pokrovitelji</Title>
          <div className="frontBoxes">
            {projects &&
              projects.edges.map(({ node }) => {
                const {
                  frontmatter: { logo, title }
                  // fields: { slug }
                } = node;
                return (
                  <div className="box">
                    <Link to={`/projekti/${kebabCase(title)}`}>
                      <img src={logo} alt={title} />
                    </Link>
                  </div>
                );
              })}
          </div>
        </Container>
      </Layout>
    );
  }
}

HomePage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array
    })
  })
};

export default HomePage;

export const pageQuery = graphql`
  query HomePageQuery {
    ...LayoutFragment
    homePageData: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "home-page" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            bannerItems {
              image
              label
            }
            highlightTextBlock
          }
        }
      }
    }
    latestNews: allBlogMala(sort: {fields: published, order: DESC}, limit: 5) {
      edges {
        node {
          title
          published(formatString: "DD.MM.YYYY")
          mainImage
        }
      }
    }
    allBlogVelika(sort: {fields: published, order: DESC}, limit: 5) {
      edges {
        node {
          title
          published(formatString: "DD.MM.YYYY")
          mainImage
        }
      }
    }
    projects: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "projects" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            logo
          }
        }
      }
    }
  }
`;

